const infoWindow = () => {
  const open = (amap, layer) => (position) => {
    layer.window.open(amap, position)
  }

  const close = (layer) => () => {
    layer.window.close()
  }
  const setApis = (AMap, amap) => ({
    initInfoWindow: (layer, content) => {
      layer.window = new AMap.InfoWindow({
        autoMove: true,
      })
      layer.window.setContent(content)
      layer.open = open(amap, layer)
      layer.close = close(layer)
    },
  })

  return {
    amapPlugins: [],
    setApis,
  }
}

export default infoWindow
